import React, { useRef, useEffect, useState, useCallback } from 'react';

import { createStyles, makeStyles, TextField as BaseTextField } from '@material-ui/core';
import { useField } from '@unform/core';
import clsx from 'clsx';

import { TextFieldProps as BaseTextFieldProps } from '@material-ui/core/TextField/TextField';

export type TextFieldProps = BaseTextFieldProps & {
    name: string;
    emptyMask?: string; 
};

const useStyles = makeStyles(() =>
    createStyles({
        root: {
            margin: '10px',
        },
    })
);

// const inputBase = makeStyles({
//     formControl: {
//         "label + &": {
//             marginTop: "1px"
//         }
//     },
// }, { name: 'MuiInput' });


// const formLabelStyles = makeStyles({
//     root: {
//         position: "relative",
//     },
// }, { name: 'MuiInputLabel' });

const TextField: React.FC<TextFieldProps> = ({
    name,
    helperText,
    defaultValue,
    InputLabelProps,
    emptyMask,
    autoFocus,
    ...restProps
}) => {

    const inputRef = useRef<HTMLInputElement | null>(null);
    const {
        fieldName,
        defaultValue: fieldDefaultValue,
        registerField,
        error,
    } = useField(name);
    const defaultInputValue = fieldDefaultValue || defaultValue;
    const [shrink, setShrink] = useState<boolean>(false);

    useEffect(() => {
        if (fieldName) {
            registerField({
                name: fieldName,
                ref: inputRef.current,
                path: 'value',
                setValue(ref: HTMLInputElement, value: string) {
                    if (ref) {
                        ref.value = value;
                    }
                    setShrink(!!value);
                },
            });
        }
    }, [fieldName, registerField]);

    useEffect(() => {
        const input = inputRef.current;

        setShrink(!autoFocus && (defaultInputValue == undefined || defaultInputValue == null || defaultInputValue === '') ? false : true)

        if (input) {

            if(autoFocus)
                input.focus();

            input.addEventListener('focusin', () => {
                setShrink(true)
              });
              
            input.addEventListener('focusout', (event : any) => {
                setShrink(event.target.value && (!emptyMask || event.target.value != emptyMask) ? true : false)
              });
        }
    }, [inputRef]);

    const classes = useStyles();
    //const formLabelClass = formLabelStyles();
    //const inputBaseClass = inputBase();

    

    return (
        <BaseTextField
            {...restProps}
            className={clsx(classes.root)}
            name={fieldName}
            error={!!error}
            helperText={error || helperText}
            inputRef={inputRef}
            defaultValue={defaultInputValue}
            InputLabelProps={{
                ...InputLabelProps,
                shrink,
            }}
        />
    );
};

export default React.memo(TextField);
